export const HERO_CONSTANTS = {
  button: {
    label: "Run Smarter. Scale Faster. Migrate with Confidence.",
    link: "#contact-us",
  },
  content: " Migrate to Zadara with OneMind’s Proven Automation & Cloud Expertise ",
  title: "Elastic Infrastructure. Zero Headaches. Only Zadara.",
};
